module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Black_MockedUp.2112efc9.jpg";